import pick from 'lodash/fp/pick';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

const BASE_PATHNAME = 'sponsors';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const create = ({ values, eventId }) => dataSource.post(BASE_PATHNAME, { json: { ...values, eventId } }).json();
  const update = ({ id, values, eventId }) =>
    dataSource.put(`${BASE_PATHNAME}`, { json: { ...values, eventId, id } }).json();

  const save = async ({ id, values, eventId }) => (id ? update({ id, values, eventId }) : create({ values, eventId }));

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['eventId']),
    }),

    getById,

    getByIds,

    remove,

    create,

    update,

    save,

    getEmptyList: getDefaultEmptyList,
  };
};
